(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  // Reuse Prestige's modal, including its focus trap, close events and overlay.
  // The guard allows this section to be re-rendered safely in the theme editor.
  window.customElements.whenDefined('x-modal').then(() => {
    if (window.customElements.get('lm-newsletter-popup')) return;
    const PrestigeModal = window.customElements.get('x-modal');
    class LMNewsletterPopup extends PrestigeModal {
      connectedCallback() {
        super.connectedCallback();
        const signal = this.abortController.signal;
        this.addEventListener('dialog:before-show', () => {
          if (!window.Shopify.designMode) this.writeStorage('localStorage', 'lmnp:last-shown', String(Date.now()));
        }, { signal });
        this.querySelector('form')?.addEventListener('submit', () => {
          if (!window.Shopify.designMode) {
            this.writeStorage('sessionStorage', 'lmnp:pending', JSON.stringify({ id: this.id, at: Date.now() }));
          }
        }, { signal });
        // Prestige moves open modals to <body>. Do not restart timing when that reconnects this element.
        if (this._lmnpStarted) return;
        this._lmnpStarted = true;
        this._lmnpTimer = null;
        if (window.Shopify.designMode) {
          if (this.dataset.editorPreview === 'true') this.scheduleOpen(0);
          return;
        }
        const response = this.querySelector('[data-lmnp-response]')?.dataset.lmnpResponse;
        const pendingText = this.readStorage('sessionStorage', 'lmnp:pending');
        let pending = null;
        try { pending = JSON.parse(pendingText || 'null'); } catch (_) { /* storage may be unavailable */ }
        const recentlySubmitted = pending?.id === this.id && Date.now() - pending.at < 30 * 60 * 1000;
        const ownFormHash = window.location.hash === '#' + this.querySelector('form')?.id;
        if ((response === 'success' || response === 'error') && (recentlySubmitted || ownFormHash)) {
          this.removeStorage('sessionStorage', 'lmnp:pending');
          if (response === 'success') this.writeStorage('localStorage', 'theme:popup-filled', 'true');
          this.scheduleOpen(0);
          return;
        }
        // Another newsletter form can also set Shopify's page-wide form response.
        if (response === 'success') {
          this.writeStorage('localStorage', 'theme:popup-filled', 'true');
          return;
        }
        if (response === 'error') return;
        if (this.dataset.enabled !== 'true' || this.dataset.knownSubscriber === 'true') return;
        if (this.readStorage('localStorage', 'theme:popup-filled') === 'true') return;
        if (this.dataset.homeOnly === 'true' && this.dataset.isHome !== 'true') return;
        const lastShown = Number(this.readStorage('localStorage', 'lmnp:last-shown')) || 0;
        if (lastShown && this.dataset.onlyOnce === 'true') return;
        const repeatAfter = Number(this.dataset.repeatDays || 7) * 86400000;
        if (lastShown && Date.now() - lastShown < repeatAfter) return;
        this.scheduleOpen(Number(this.dataset.delay || 5) * 1000);
      }
      disconnectedCallback() {
        window.clearTimeout(this._lmnpTimer);
        super.disconnectedCallback();
      }
      scheduleOpen(delay) {
        window.clearTimeout(this._lmnpTimer);
        this._lmnpTimer = window.setTimeout(() => {
          if (!this.isConnected || this.open) return;
          // Wait until the visitor has closed another theme dialog or switched back to this tab.
          const otherDialog = document.querySelector('.modal[open], .drawer[open], .popover[open], .header-search[open]');
          if (document.hidden || (otherDialog && otherDialog !== this)) {
            this.scheduleOpen(1000);
            return;
          }
          this.show(!window.matchMedia('(prefers-reduced-motion: reduce)').matches);
        }, delay);
      }
      readStorage(type, key) {
        try { return window[type].getItem(key); } catch (_) { return null; }
      }
      writeStorage(type, key, value) {
        try { window[type].setItem(key, value); } catch (_) { /* Popup still works without browser storage. */ }
      }
      removeStorage(type, key) {
        try { window[type].removeItem(key); } catch (_) { /* Browser storage can be blocked. */ }
      }
      createEnterAnimationControls() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return this.instantAnimation();
        return super.createEnterAnimationControls();
      }
      createLeaveAnimationControls() {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return this.instantAnimation();
        return super.createLeaveAnimationControls();
      }
      instantAnimation() {
        return { finished: Promise.resolve(), finish() {} };
      }
    }
    window.customElements.define('lm-newsletter-popup', LMNewsletterPopup);
  });

  } catch(e) { console.error(e); }
})();
})();
